export default {
  name: `loading_screen`,
  images: {
    background: require(`@/assets/splashscreen/splashscreen_background.png`),
    typo: require(`@/assets/logos/logo.png`),
    logo: require(`@/assets/logos/logo_vca.png`),
    butterfly: require(`@/assets/common/papillon_jaune.png`),
  },
}